module.exports = __webpack_public_path__ + "static/media/banner.24fbdf2d.svg";